import { render, staticRenderFns } from "./SendReportToBhView.vue?vue&type=template&id=236afa99&scoped=true&"
import script from "./SendReportToBhView.vue?vue&type=script&lang=ts&"
export * from "./SendReportToBhView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236afa99",
  null
  
)

export default component.exports